/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { AirtimeDeviceDto } from '../model/airtimeDeviceDto';
// @ts-ignore
import { AirtimeDeviceRequestDto } from '../model/airtimeDeviceRequestDto';
// @ts-ignore
import { LongRangeDeviceDto } from '../model/longRangeDeviceDto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class LongRangeDevicesService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * @param oldDataPlan 
     * @param newDataPlan 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public checkDataPlanChange(oldDataPlan?: 'UNLIMITED' | 'THREE_KBYTE' | 'SMITHSONIAN_SPECIAL' | 'POOLED_THREE_KBYTE' | 'POOLED_TWELVE_KBYTE' | 'TEST_2_5_KBYTE' | 'TEST_4_KBYTE', newDataPlan?: 'UNLIMITED' | 'THREE_KBYTE' | 'SMITHSONIAN_SPECIAL' | 'POOLED_THREE_KBYTE' | 'POOLED_TWELVE_KBYTE' | 'TEST_2_5_KBYTE' | 'TEST_4_KBYTE', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public checkDataPlanChange(oldDataPlan?: 'UNLIMITED' | 'THREE_KBYTE' | 'SMITHSONIAN_SPECIAL' | 'POOLED_THREE_KBYTE' | 'POOLED_TWELVE_KBYTE' | 'TEST_2_5_KBYTE' | 'TEST_4_KBYTE', newDataPlan?: 'UNLIMITED' | 'THREE_KBYTE' | 'SMITHSONIAN_SPECIAL' | 'POOLED_THREE_KBYTE' | 'POOLED_TWELVE_KBYTE' | 'TEST_2_5_KBYTE' | 'TEST_4_KBYTE', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public checkDataPlanChange(oldDataPlan?: 'UNLIMITED' | 'THREE_KBYTE' | 'SMITHSONIAN_SPECIAL' | 'POOLED_THREE_KBYTE' | 'POOLED_TWELVE_KBYTE' | 'TEST_2_5_KBYTE' | 'TEST_4_KBYTE', newDataPlan?: 'UNLIMITED' | 'THREE_KBYTE' | 'SMITHSONIAN_SPECIAL' | 'POOLED_THREE_KBYTE' | 'POOLED_TWELVE_KBYTE' | 'TEST_2_5_KBYTE' | 'TEST_4_KBYTE', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public checkDataPlanChange(oldDataPlan?: 'UNLIMITED' | 'THREE_KBYTE' | 'SMITHSONIAN_SPECIAL' | 'POOLED_THREE_KBYTE' | 'POOLED_TWELVE_KBYTE' | 'TEST_2_5_KBYTE' | 'TEST_4_KBYTE', newDataPlan?: 'UNLIMITED' | 'THREE_KBYTE' | 'SMITHSONIAN_SPECIAL' | 'POOLED_THREE_KBYTE' | 'POOLED_TWELVE_KBYTE' | 'TEST_2_5_KBYTE' | 'TEST_4_KBYTE', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>oldDataPlan, 'oldDataPlan');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>newDataPlan, 'newDataPlan');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/devices/longrange/check-data-plan-change`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param rangeStart 
     * @param rangeEnd 
     * @param comType 
     * @param airtimeDeviceRequestDto 
     * @param comProvider 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getActiveAirtimeDevicesForTimeRange(rangeStart: string, rangeEnd: string, comType: 'IRIDIUM' | 'GLOBALSTAR' | 'NB_IOT' | 'NO_COMMUNICATION' | 'GSM', airtimeDeviceRequestDto: AirtimeDeviceRequestDto, comProvider?: 'GROUND_CONTROL' | 'MET_OCEAN' | 'GLOBALSTAR' | 'ORBCOMM' | 'IRIDIUM_JAPAN', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<AirtimeDeviceDto>>;
    public getActiveAirtimeDevicesForTimeRange(rangeStart: string, rangeEnd: string, comType: 'IRIDIUM' | 'GLOBALSTAR' | 'NB_IOT' | 'NO_COMMUNICATION' | 'GSM', airtimeDeviceRequestDto: AirtimeDeviceRequestDto, comProvider?: 'GROUND_CONTROL' | 'MET_OCEAN' | 'GLOBALSTAR' | 'ORBCOMM' | 'IRIDIUM_JAPAN', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<AirtimeDeviceDto>>>;
    public getActiveAirtimeDevicesForTimeRange(rangeStart: string, rangeEnd: string, comType: 'IRIDIUM' | 'GLOBALSTAR' | 'NB_IOT' | 'NO_COMMUNICATION' | 'GSM', airtimeDeviceRequestDto: AirtimeDeviceRequestDto, comProvider?: 'GROUND_CONTROL' | 'MET_OCEAN' | 'GLOBALSTAR' | 'ORBCOMM' | 'IRIDIUM_JAPAN', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<AirtimeDeviceDto>>>;
    public getActiveAirtimeDevicesForTimeRange(rangeStart: string, rangeEnd: string, comType: 'IRIDIUM' | 'GLOBALSTAR' | 'NB_IOT' | 'NO_COMMUNICATION' | 'GSM', airtimeDeviceRequestDto: AirtimeDeviceRequestDto, comProvider?: 'GROUND_CONTROL' | 'MET_OCEAN' | 'GLOBALSTAR' | 'ORBCOMM' | 'IRIDIUM_JAPAN', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (rangeStart === null || rangeStart === undefined) {
            throw new Error('Required parameter rangeStart was null or undefined when calling getActiveAirtimeDevicesForTimeRange.');
        }
        if (rangeEnd === null || rangeEnd === undefined) {
            throw new Error('Required parameter rangeEnd was null or undefined when calling getActiveAirtimeDevicesForTimeRange.');
        }
        if (comType === null || comType === undefined) {
            throw new Error('Required parameter comType was null or undefined when calling getActiveAirtimeDevicesForTimeRange.');
        }
        if (airtimeDeviceRequestDto === null || airtimeDeviceRequestDto === undefined) {
            throw new Error('Required parameter airtimeDeviceRequestDto was null or undefined when calling getActiveAirtimeDevicesForTimeRange.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>rangeStart, 'rangeStart');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>rangeEnd, 'rangeEnd');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>comType, 'comType');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>comProvider, 'comProvider');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/devices/longrange/airtime-devices`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<AirtimeDeviceDto>>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: airtimeDeviceRequestDto,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param deviceId 
     * @param feature 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFeatureAvailableByLongRangeDeviceId(deviceId: number, feature: 'REMOTE_COMMAND_SET_LONG_PARAMETER' | 'ONLY_POSITION_SHORT_HEADER_MESSAGE_FORMAT' | 'SHORT_HEADER_MESSAGE_FORMAT' | 'LEGACY_MESSAGE_FORMAT' | 'HIGH_ACTIVITY_CAMERA_TRIGGER' | 'BROKEN_SCHEDULE_PERIOD_LENGTH' | 'BROKEN_USER_PARAMETER_VIA_REMOTE_COMMAND', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<boolean>;
    public getFeatureAvailableByLongRangeDeviceId(deviceId: number, feature: 'REMOTE_COMMAND_SET_LONG_PARAMETER' | 'ONLY_POSITION_SHORT_HEADER_MESSAGE_FORMAT' | 'SHORT_HEADER_MESSAGE_FORMAT' | 'LEGACY_MESSAGE_FORMAT' | 'HIGH_ACTIVITY_CAMERA_TRIGGER' | 'BROKEN_SCHEDULE_PERIOD_LENGTH' | 'BROKEN_USER_PARAMETER_VIA_REMOTE_COMMAND', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<boolean>>;
    public getFeatureAvailableByLongRangeDeviceId(deviceId: number, feature: 'REMOTE_COMMAND_SET_LONG_PARAMETER' | 'ONLY_POSITION_SHORT_HEADER_MESSAGE_FORMAT' | 'SHORT_HEADER_MESSAGE_FORMAT' | 'LEGACY_MESSAGE_FORMAT' | 'HIGH_ACTIVITY_CAMERA_TRIGGER' | 'BROKEN_SCHEDULE_PERIOD_LENGTH' | 'BROKEN_USER_PARAMETER_VIA_REMOTE_COMMAND', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<boolean>>;
    public getFeatureAvailableByLongRangeDeviceId(deviceId: number, feature: 'REMOTE_COMMAND_SET_LONG_PARAMETER' | 'ONLY_POSITION_SHORT_HEADER_MESSAGE_FORMAT' | 'SHORT_HEADER_MESSAGE_FORMAT' | 'LEGACY_MESSAGE_FORMAT' | 'HIGH_ACTIVITY_CAMERA_TRIGGER' | 'BROKEN_SCHEDULE_PERIOD_LENGTH' | 'BROKEN_USER_PARAMETER_VIA_REMOTE_COMMAND', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (deviceId === null || deviceId === undefined) {
            throw new Error('Required parameter deviceId was null or undefined when calling getFeatureAvailableByLongRangeDeviceId.');
        }
        if (feature === null || feature === undefined) {
            throw new Error('Required parameter feature was null or undefined when calling getFeatureAvailableByLongRangeDeviceId.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>deviceId, 'deviceId');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>feature, 'feature');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/devices/longrange/is-feature-available`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<boolean>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param deviceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFeaturesByLongRangeDeviceId(deviceId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<string>>;
    public getFeaturesByLongRangeDeviceId(deviceId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<string>>>;
    public getFeaturesByLongRangeDeviceId(deviceId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<string>>>;
    public getFeaturesByLongRangeDeviceId(deviceId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (deviceId === null || deviceId === undefined) {
            throw new Error('Required parameter deviceId was null or undefined when calling getFeaturesByLongRangeDeviceId.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>deviceId, 'deviceId');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/devices/longrange/available-features`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<string>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLongRangeDeviceById(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<LongRangeDeviceDto>;
    public getLongRangeDeviceById(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<LongRangeDeviceDto>>;
    public getLongRangeDeviceById(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<LongRangeDeviceDto>>;
    public getLongRangeDeviceById(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getLongRangeDeviceById.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/devices/longrange/id/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<LongRangeDeviceDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param comId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLongRangeDeviceIdByComId(comId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<string>;
    public getLongRangeDeviceIdByComId(comId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<string>>;
    public getLongRangeDeviceIdByComId(comId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<string>>;
    public getLongRangeDeviceIdByComId(comId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (comId === null || comId === undefined) {
            throw new Error('Required parameter comId was null or undefined when calling getLongRangeDeviceIdByComId.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>comId, 'comId');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/devices/longrange/get-id-by-com-id`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<string>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLongRangeDeviceKey(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<string>;
    public getLongRangeDeviceKey(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<string>>;
    public getLongRangeDeviceKey(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<string>>;
    public getLongRangeDeviceKey(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getLongRangeDeviceKey.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/devices/longrange/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}/key`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<string>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public longRangeDeviceExists(id: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<boolean>;
    public longRangeDeviceExists(id: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<boolean>>;
    public longRangeDeviceExists(id: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<boolean>>;
    public longRangeDeviceExists(id: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling longRangeDeviceExists.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/devices/longrange/exists-by-id/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<boolean>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
